import React from 'react';

import { IconRawSvg } from '../IconRawSvg';
import styled from '@emotion/styled';
import { classNames } from '../../services/classNames';

interface BubbleSVG {
    backgroundSvgName: string;
    centerContentVertically?: boolean | any;
    centerContentHorizontally?: boolean | any;
    transition?: boolean | any;
}

export const BubbleSVG: React.FC<BubbleSVG> = ({
    children,
    backgroundSvgName,
    centerContentVertically,
    centerContentHorizontally,
    transition = true,
    ...props
}) => {
    return (
        <Wrapper
            className={classNames(
                'BubbleSVG',
                `BubbleSVG--${backgroundSvgName}`,
            )}
            transition={transition}
            {...props}
        >
            <IconRawSvg name={backgroundSvgName} />
            <ContentWrapper
                className="BubbleSVG__content-wrapper"
                centeredHorizontally={centerContentHorizontally}
                centeredVertically={centerContentVertically}
            >
                <Content className="BubbleSVG___content">{children}</Content>
            </ContentWrapper>
        </Wrapper>
    );
};

const Wrapper = styled.div<{ transition: boolean }>`
    display: inline-flex;

    position: relative;
    transform: scale(1);

    ${(props) =>
        props.transition &&
        `
            transition: transform 0.3s ease;

            &:hover {
                transform: scale(1.05);
            }
    `}
`;

export const ContentWrapper = styled.div<{
    centeredVertically: boolean;
    centeredHorizontally: boolean;
}>`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    padding: 18% 15% 10% 15%;

    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    ${(props) => props.centeredHorizontally && `justify-content: center;`}
    ${(props) => props.centeredVertically && `align-items: center;`}
`;

const Content = styled.div`
    color: white;
`;
